import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";

export const filterScreenType = {
  MYAPPOINTMENT: "myappointment",
  MYTRANSACTION: "mytransactions",
};

// get filter data here ==>
export const filterAPICall = async (apiURL, params) => {
  try {
    const res = await afterLoginApiAxios({
      method: "post",
      url: apiURL,
      data: params,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
    });

    if (res?.data && res?.data?.procedures?.length > 0) {
      let modifiedResponse = [];

      res.data.procedures.map((data, index) => {
        let obj = {};
        obj["name"] = data;
        obj["value"] = data;
        obj["type"] = "procedure";
        modifiedResponse.push(obj);
      });
      return [modifiedResponse, false];
    } else {
      return [[], false];
    }
  } catch (err) {
    return [[], true];
  }
};

// <==
